/* ==========================================================================
   OUTLYRS CLUB — product-recommendations.js
   Fetches Shopify product recommendations and injects the rendered section.
   ========================================================================== */
(function () {
  "use strict";

  function load(el) {
    var url = el.getAttribute("data-url");
    if (!url) return;
    fetch(url, { headers: { Accept: "text/html" } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-recs]");
        if (!fresh || !fresh.innerHTML.trim()) return;
        // Never downgrade: only swap in the fetched row if it has at least as
        // many products as the one already rendered.
        var freshCount = fresh.querySelectorAll(".recs__grid > li").length;
        var currentCount = el.querySelectorAll(".recs__grid > li").length;
        if (freshCount >= currentCount) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll("[data-recs]").forEach(function (el) {
      if (el.dataset.loaded) return;
      el.dataset.loaded = "true";
      load(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
